import { render } from "./CourseQA.vue?vue&type=template&id=ed3ec7f6&scoped=true"
import script from "./CourseQA.vue?vue&type=script&lang=js"
export * from "./CourseQA.vue?vue&type=script&lang=js"

import "./CourseQA.vue?vue&type=style&index=0&id=ed3ec7f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed3ec7f6"]])

export default __exports__